import { NgModule } from "@angular/core";
import {
    CommonModule,
    DatePipe,
    DecimalPipe,
    TitleCasePipe,
} from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MenubarModule } from "primeng/menubar";
import { MenuModule } from "primeng/menu";
import { InputTextModule } from "primeng/inputtext";
import { TabMenuModule } from "primeng/tabmenu";
import { TableModule } from "primeng/table";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { TabViewModule } from "primeng/tabview";
import { ContextMenuModule } from "primeng/contextmenu";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { TooltipModule } from "primeng/tooltip";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmationService, MessageService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputSwitchModule } from "primeng/inputswitch";
import { MultiSelectModule } from "primeng/multiselect";
import { ToggleButtonModule } from "primeng/togglebutton";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { SalesOrderComponent } from "./sales-order.component";
import { SlideMenuModule } from "primeng/slidemenu";
import { CalendarModule } from "primeng/calendar";
import { CarouselModule } from "primeng/carousel";
import { FileUploadModule } from "primeng/fileupload";
import { RatingModule } from "primeng/rating";
import {StepsModule} from 'primeng/steps';
import { CardModule } from "primeng/card";
import {SpeedDialModule} from 'primeng/speeddial';
import {EditorModule} from 'primeng/editor';
import {BadgeModule} from 'primeng/badge';
import { TieredMenuModule } from 'primeng/tieredmenu';

import { SalesOrderAddEditComponent } from "./sales-order-add-edit/sales-order-add-edit.component";
import { CreditMemoAddEditComponent } from "./credit-memo-add-edit/credit-memo-add-edit.component";
import { SharedComponentModule } from "src/app/modules/shared/shared.module";

import { AutoCompleteModule } from "primeng/autocomplete";
import { PanelModule } from "primeng/panel";
import { ToastModule } from "primeng/toast";
import { InvoicePdfComponent } from "./shared/invoice-pdf/invoice-pdf.component";

// Import ngx-barcode module
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ReturnAddEditComponent } from './return-add-edit/return-add-edit.component';
import { ReturnDetailsComponent } from './return-details/return-details.component';
import { CustomAttributeComponent } from "./shared/custom-attribute/custom-attribute.component";
import { ReturnPrintEmailComponent } from "./shared/return-print-email/return-print-email.component";
import { MulticurrencyPipe } from "src/app/modules/shared/pipes/multicurrency.pipe";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesReceiptPdfComponent } from "src/app/sales-receipt-pdf/sales-receipt-pdf.component";
import { SalesReceiptDetailsComponent } from "./sales-receipt-details/sales-receipt-details.component";
import { PaginatorModule } from "primeng/paginator";

const routes: Routes = [
    {
        path: "",
        component: SalesOrderComponent,
    },
];

@NgModule({
    declarations: [
        SalesOrderComponent,
        SalesOrderAddEditComponent,
        CreditMemoAddEditComponent,
        InvoicePdfComponent,
        ReturnAddEditComponent,
        ReturnDetailsComponent,
        ReturnPrintEmailComponent,
        CustomAttributeComponent,
        SalesReceiptPdfComponent ,
        SalesReceiptDetailsComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        DropdownModule,
        FormsModule,
        ReactiveFormsModule,
        MenubarModule,
        InputTextModule,
        TabMenuModule,
        TableModule,
        OverlayPanelModule,
        PanelModule,
        TabViewModule,
        MenuModule,
        ContextMenuModule,
        DialogModule,
        ButtonModule,
        DragDropModule,
        CheckboxModule,
        ConfirmDialogModule,
        InputSwitchModule,
        MultiSelectModule,
        InputNumberModule,
        RadioButtonModule,
        TooltipModule,
        ToggleButtonModule,
        MessagesModule,
        MessageModule,
        SlideMenuModule,
        CalendarModule,
        CarouselModule,
        FileUploadModule,
        RatingModule,
        StepsModule,
        ToastModule,
        AutoCompleteModule,
        SharedComponentModule,
        PaginatorModule,
        NgxBarcode6Module,
        CardModule,
        SpeedDialModule,
        EditorModule,
        BadgeModule,
        TieredMenuModule
    ],
    exports: [],
    providers: [
        ConfirmationService,
        MessageService,
        DatePipe,
        DecimalPipe,
        TitleCasePipe,
        MulticurrencyPipe,
        AppMainComponent
    ],
})
export class SalesOrderModule {}
